import React, { useState, useEffect } from 'react';
import './LoadingMessages.css';
import loadingImage from './HomePagee.png';

const LoadingMessages = () => {
	const [isLoading, setIsLoading] = useState(true);
	const [progress, setProgress] = useState(0);

	useEffect(() => {
		// Simulate loading delay
		const loadingInterval = setInterval(() => {
			setProgress(prevProgress => prevProgress + 10);
		}, 200);

		setTimeout(() => {
			clearInterval(loadingInterval);
			setIsLoading(false);
		}, 2000);

		return () => {
			clearInterval(loadingInterval);
		};
	}, []);

	return (
		<div className="loading-container">
			{isLoading ? (
				<>
					{/* <img src={loadingImage} className="loading-image" alt="Loading" /> */}
					<div className="loading-bar-container">
						<div className="progress" style={{ width: `${progress}%` }} />
					</div>
					<p className="loading-text">Loading Your Chats... {progress}%</p>
				</>
			) : (
				<div className="loaded">
					<p>Your messages are loaded.</p>
				</div>
			)}
		</div>
	);
};

export default LoadingMessages;
